module.exports = __webpack_public_path__ + "static/media/033-connection.4c8c76dc.svg";